import api from '../utils/api';

export const reportService = {
  getSummary: async (startDate, endDate, filters = {}) => {
    const response = await api.get('/api/reports/summary', { params:{ start_date:startDate, end_date:endDate, ...filters } });
    return response.data.data;
  },
  // รายงานต้นทุนสินค้าคงเหลือ
  getInventoryReport: async (category = '', lowStock = false) => {
    try {
      const params = new URLSearchParams();
      if (category) params.append('category', category);
      if (lowStock) params.append('low_stock', 'true');
      
      const response = await api.get(`/api/reports/inventory-cost?${params.toString()}`);
      console.log('รายงานต้นทุนสินค้าคงเหลือ', response)
      return response.data.data;
    } catch (error) {
      console.error('Error fetching inventory report:', error);
      throw error;
    }
  },

  // รายงานยอดขาย
  getSalesReport: async (startDate, endDate, contactId = '', groupBy = 'day') => {
    try {
      const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
        group_by: groupBy
      });
      if (contactId) params.append('contact_id', contactId);
      
      const response = await api.get(`/api/reports/sales?${params.toString()}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching sales report:', error);
      throw error;
    }
  },

  // รายงานค่าใช้จ่าย
  getExpensesReport: async (startDate, endDate, category = '', status = '', groupBy = 'day') => {
    try {
      const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
        group_by: groupBy
      });
      if (category) params.append('category', category);
      if (status) params.append('status', status);
      
      const response = await api.get(`/api/reports/expenses?${params.toString()}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching expenses report:', error);
      throw error;
    }
  },

  // รายงานงบการเงิน
  getFinancialReport: async (startDate, endDate) => {
    try {
      const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate
      });
      
      const response = await api.get(`/api/reports/financial?${params.toString()}`);
      console.log('response',response)
      return response.data.data;
    } catch (error) {
      console.error('Error fetching financial report:', error);
      throw error;
    }
  },

  // รายงานกำไร/ขาดทุน
  getProfitLossReport: async (startDate, endDate, period = 'month') => {
    try {
      const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
        period: period
      });
      
      const response = await api.get(`/api/reports/profit-loss?${params.toString()}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching profit loss report:', error);
      throw error;
    }
  },

  // รายงาน Dashboard
  getDashboardReport: async (startDate, endDate) => {
    try {
      const response = await api.get('/api/reports/dashboard', { params:{start_date:startDate,end_date:endDate} });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching dashboard report:', error);
      throw error;
    }
  }
};

export default reportService;
